import { Component, OnInit } from '@angular/core';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';



@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements OnInit {

  

  constructor(private translate : TranslateFirebaseService) { }

  async ngOnInit() {

    await this.translate.redirectToStore();
  }

  ngAfterViewInit(): void {
    
  }




}
